(function () {
    'use strict';

    angular
        .module('app')
        .controller('TagEditCtrl', TagEditCtrl);

    TagEditCtrl.$inject = [
        '$scope',
        '$q',
        '$routeParams',
        'DialogService',
        'TagsService',
        'LastUpdatedService',
        'NavigationAidService',
        'ObjectSaveErrorHandlerService',
        'UnsavedChangesService',
        'ChilliUserProfileService',
        'WindowTitleService'];

    function TagEditCtrl(
        $scope,
        $q,
        $routeParams,
        DialogService,
        TagsService,
        LastUpdatedService,
        NavigationAidService,
        ObjectSaveErrorHandlerService,
        UnsavedChangesService,
        ChilliUserProfileService,
        WindowTitleService) {

        /* jshint validthis:true */
        var vm = this;
        vm.tag = {};
        vm.saveTag = saveTag;
        vm.deleteTag = deleteTag;
        vm.showTagUsage = showTagUsage;
        vm.close = close;
        vm.loading = true;
        vm.permissionDenied = false;
        vm.notFound = false;
        vm.viewTitle = 'Tag';
        Object.defineProperty(vm, 'dirty', {
            get: function () { return !_.isNil(UnsavedChangesService) && UnsavedChangesService.dirty; }
        });
        Object.defineProperty(vm, 'lastUpdatedLabel', {
            get: function () { return LastUpdatedService.getLabel(vm.tag); }
        });
        Object.defineProperty(vm, 'tagIsNew', {
            get: function () { return !($routeParams.id && $routeParams.id !== 'new'); }
        });

        vm.tagUsage = [];
        Object.defineProperty(vm, 'tagUsageAll', {
            get: function () {
                return _.contains(vm.tag.Usage, 'All');
            },
            set: function (allUsage) {
                vm.tag.Usage.length = 0;
                vm.tagUsage.length = 0;
                if (allUsage) {
                    vm.tag.Usage.push('All');
                }
            }
        });

        activate();

        function activate() {
            updateViewTitle();

            ChilliUserProfileService.verifyUserIsAdministrator({
                onUserIsAdmin: loadData,
                onUserIsNotAdmin: function () { vm.permissionDenied = true; },
                onError: function (response) { DialogService.error('Error loading User profile', response); },
                onFinally: function () {
                    vm.loading = false;
                    updateViewTitle();

                    UnsavedChangesService.register({
                        scope: $scope,
                        modelExpression: 'vm.tag',
                            saveFunction: saveTag,
                        unsavedItemName: 'Tag'
                    });
                }
            });
        }

        function loadData() {
            var loadPromises = [];
            loadPromises.push(loadTag());
            loadPromises.push(loadUsageAreas());

            function mapTagUsage() {
                _.forEach(vm.tag.Usage, function (usageReference) {
                    vm.tagUsage = vm.tagUsage.concat(_.filter(vm.usageAreas, { Reference: usageReference }));
                });

                $scope.$watchCollection('vm.tagUsage', function (newTagUsage) {
                    if (!vm.tagUsageAll) {
                        vm.tag.Usage = _.map(newTagUsage, 'Reference');
                    }
                });
            }

            return $q.all(loadPromises).then(mapTagUsage);
        }

        function loadTag() {
            var loadPromise;
            if (!vm.tagIsNew) {
                loadPromise = TagsService.get($routeParams.id);
            } else {
                loadPromise = $q.when(newTag());
            }

            return loadPromise
                .then(getTagOk, getTagError);

            function getTagOk(data) {
                vm.tag = data;
            }

            function getTagError(response) {
                if (response.status === 404) {
                    vm.notFound = true;
                } else {
                    DialogService.error('Error fetching Tag', response);
                }
            }
        }

        /**
         * Load the list of areas where tags can be used throughout ChilliDocs
         */
        function loadUsageAreas() {
            return TagsService.getUsageAreas()
                .then(getUsageAreasOk, getUsageAreasError);

            function getUsageAreasOk(data) {
                vm.usageAreas = _.filter(data, function (usage) { return usage.Reference !== 'All'; });
            }

            function getUsageAreasError(response) {
                DialogService.error('Error fetching Tag usage areas', response);
            }
        }

        /**
         * Update Title to be shown at the top of the view and browser window/tab title.
         */
        function updateViewTitle() {
            var title = 'Tag';

            if (!_.isNil($routeParams.id) && $routeParams.id !== '') {
                if ($routeParams.id === 'new') {
                    title = 'Add ' + title;
                } else if (!_.isNil(vm.tag) && !_.isNil(vm.tag.Name) && vm.tag.Name.length) {
                    title += ' - ' + vm.tag.Name;
                }
            }

            vm.viewTitle = title;
            WindowTitleService.setTitle(title);
        }

        function saveTag() {
            return TagsService.query()
                .then(getTagsOk, getTagsError);

            function getTagsOk(data) {
                if (!_.isNil(vm.addTagForm) && vm.addTagForm.$invalid) {
                    return DialogService.messageList('Error saving tag', null, vm.addTagForm.$error)
                        .then(function () {
                            return $q.reject();
                        });
                } else if (_.some(data.Tags, function (n) { return n.Name === vm.tag.Name && n.Id !== vm.tag.Id; })) {
                    return DialogService.messageList('Error saving tag', ['Name already exists'], vm.addTagForm.$error)
                        .then(function () {
                            return $q.reject();
                    });
                } else {
                    var tagData = angular.copy(vm.tag);

                    if (vm.tagIsNew) {
                        return TagsService.save(tagData)
                            .then(saveTagOk, saveTagError);
                    } else {
                        return verifyTagUsage(tagData)
                            .then(function () {
                                return TagsService.save(tagData)
                                    .then(saveTagOk, saveTagError);
                            });
                    }
                }
            }

            /**
             * When saving changes to a tag, the user may have removed some of the valid usages.
             * This may mean that some items will have the tag removed. If so, present the user
             * with a dialog to verify that they want to proceed.
             *
             * @param {object} tagData
             * @return {promise} Resolves if the user has confirmed they are OK with the usage changes,
             *   or, the usage change will NOT remove any tags from items.
             */
            function verifyTagUsage(tagData) {
                if (_.contains(tagData.Usage, 'All')) {
                    return $q.resolve();
                }

                return TagsService.getLinkedItems([tagData.Id], tagData.Usage)
                    .then(getLinkedItemsOk, getLinkedItemsError);

                function getLinkedItemsOk(linkedItems) {
                    if (_.isNil(linkedItems) || linkedItems.length === 0) {
                        return $q.resolve();
                    }

                    return DialogService.show({
                        locals: { linkedItems: linkedItems },
                        controller: 'SaveTagDialogCtrl',
                        controllerAs: 'vm',
                        templateUrl: 'app/tag/save-tag-dialog.tmpl.html'
                    });
                }

                function getLinkedItemsError(response) {
                    DialogService.error('Error fetching Tag usage', response);
                    return $q.reject(response);
                }
            }

            function getTagsError(response) {
                return DialogService.error('Error retrieving Tags.', response);
            }

            function saveTagOk(response) {
                if (vm.tagIsNew) {
                    UnsavedChangesService.dirty = false;
                    NavigationAidService.replacePage('tags/' + response.Id);
                } else {
                    vm.tag = response;
                    vm.addTagForm.$setPristine();

                    UnsavedChangesService.register({
                        scope: $scope,
                        modelExpression: 'vm.tag',
                        saveFunction: saveTag,
                        unsavedItemName: 'Tag'
                    });

                    updateViewTitle();
                }
            }

            function saveTagError(response) {
                return ObjectSaveErrorHandlerService.handleObjectSaveError(
                    response,
                    vm.tag,
                    'Tag',
                    saveTag,
                    function () {
                        return TagsService.get($routeParams.id);
                    });
            }
        }

        /**
         * Delete the tag being edited.
         */
        function deleteTag() {
            return DialogService.show({
                locals: { tagIds: [vm.tag.Id] },
                controller: 'DeleteTagDialogCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/tag/delete-tag-dialog.tmpl.html'
            }).then(deleteOk);

            function deleteOk() {
                return TagsService.remove(vm.tag.Id)
                    .then(deleteTagOk, deleteTagError);

                function deleteTagOk(success) {
                    NavigationAidService.goBack();
                }

                function deleteTagError(response) {
                    DialogService.error('Error deleting Tag', response);
                }
            }
        }

        /**
         * Show a dialog detailing usage of the tag. I.e. Items that link this tag.
         */
        function showTagUsage() {
            TagsService.getLinkedItems([vm.tag.Id])
                .then(getLinkedItemsOk, getLinkedItemsError);

            function getLinkedItemsOk(linkedItems) {
                DialogService.show({
                    locals: { linkedItems: linkedItems },
                    controller: 'TagUsageDialogCtrl',
                    controllerAs: 'vm',
                    templateUrl: 'app/tag/tag-usage-dialog.tmpl.html'
                });
            }

            function getLinkedItemsError(response) {
                DialogService.error('Error fetching Tag usage', response);
            }
        }

        function newTag() {
            return {
                Name: '',
                ForegroundColour: 'rgb(255,255,255)',
                BackgroundColour: 'rgb(56,117,215)'
            };
        }

        function close() {
            NavigationAidService.goBack();
        }
    }
})();
